<template>
  <div v-if="documentsMetadata" class="d-flex flex-column p-3">
    <div class="customer-stats mb-3 d-flex flex-column">
      <icon-stat class="my-1" icon="circle-exclamation" align="left"
        >{{ documentsMetadata.fraudResults.fraudulent_count }} fraudulent
        documents</icon-stat
      >
      <icon-stat class="my-1" icon="file-lines" align="left"
        >{{ documentsMetadata.pagination.total }} total documents</icon-stat
      >
    </div>
    <div class="fs-exclude">
      <label><small>Notes</small></label>
      <notes />
    </div>
  </div>
  <div
    v-else
    class="d-flex align-items-center h-100 justify-content-center p-3"
  >
    <i-spinner></i-spinner>
  </div>
</template>

<script>
import { IconStat } from '@inscribe/ui-kit';
import { iSpinner } from '@inscribe/signal';
import Notes from '@/V2/customers/Notes.vue';
export default {
  components: {
    'icon-stat': IconStat,
    iSpinner,
    Notes,
  },
  props: {
    selectedCustomer: {
      type: Object,
      default: null,
    },
  },
  computed: {
    documentsMetadata() {
      return this.$store.state.documentsMetadata;
    },
  },
};
</script>

<style lang="scss">
.customer-stats {
  font-size: $font-size-secondary;
  .icon-stat svg {
    width: 14px;
  }
}
</style>
